module.exports = function (S) {
  const svgroot = S.svgroot;
  const canvas = S.canvas;
  const curConfig = S.curConfig;

  const NS = svgedit.NS;
  let isEnabled = false;

  const svgdoc = document.getElementById('svgcanvas').ownerDocument;
  const assignAttributes = canvas.assignAttributes;
  const hcanvas = document.createElement('canvas');

  let gridimg;
  let canvasGrid;

  function init ()	{
    $(hcanvas).hide().appendTo('body');

    gridimg = svgdoc.createElementNS(NS.SVG, 'image');
    canvasGrid = svgdoc.createElementNS(NS.SVG, 'svg');

    const canvBG = $('#svgpanel');

    assignAttributes(canvasGrid, {
      id: 'canvasGrid',
      width: '100%',
      height: '100%',
      x: 0,
      y: 0,
      overflow: 'visible',
      style: 'pointer-events: none; display:none;'
    });
    canvBG.append(canvasGrid);

    // grid-pattern
    const gridPattern = svgdoc.createElementNS(NS.SVG, 'pattern');
    assignAttributes(gridPattern, {
      id: 'gridpattern',
      patternUnits: 'userSpaceOnUse',
      x: 0,
      y: 0,
      width: 100,
      height: 100
    });

    assignAttributes(gridimg, {
      x: 0,
      y: 0,
      width: 100,
      height: 100
    });
    gridPattern.appendChild(gridimg);

    if (!$('#svgroot > defs').length)			{
      $('#svgroot').append('<defs></defs>');
    }

    $('#svgroot > defs').first().append(gridPattern);

    // grid-box
    const gridBox = svgdoc.createElementNS(NS.SVG, 'rect');
    assignAttributes(gridBox, {
      width: '100%',
      height: '100%',
      x: 0,
      y: 0,
      'stroke-width': 0,
      stroke: 'none',
      fill: 'url(#gridpattern)',
      style: 'pointer-events: none;'
    });
    $('#canvasGrid').append(gridBox);
  }

  function updateGrid (zoom)	{
    if (!canvasGrid)			{
      return;
    }

    const svgcontent = $('#svgcontent').get(0);
    assignAttributes(canvasGrid, {
      width: Math.floor((svgcontent.getAttribute('width') * zoom)),
      height: Math.floor((svgcontent.getAttribute('height') * zoom)),
      x: Math.floor((svgcontent.getAttribute('x') * zoom)),
      y: Math.floor((svgcontent.getAttribute('y') * zoom))
    });

    const multi = 100;
    const size = multi * zoom * canvas.zoomMultiplier;

    // Set the canvas size to the width of the container
    hcanvas.width = size;
    hcanvas.height = size;
    const ctx = hcanvas.getContext('2d');
    const cur_d = 0.5;
    const part = size / 5;

    ctx.globalAlpha = 0.2;
    ctx.strokeStyle = curConfig.gridColor;
    ctx.setLineDash([2, 2]);
    for (let i = 1; i < 5; i++)		{
      const sub_d = Math.floor(part * i) + 0.5;
      // var line_num = (i % 2)?12:10;
      const line_num = 0;
      ctx.moveTo(sub_d, size);
      ctx.lineTo(sub_d, line_num);
      ctx.moveTo(size, sub_d);
      ctx.lineTo(line_num, sub_d);
    }
    ctx.stroke();
    ctx.beginPath();
    ctx.globalAlpha = 0.3;
    ctx.setLineDash([5, 3]);
    ctx.moveTo(cur_d, size);
    ctx.lineTo(cur_d, 0);

    ctx.moveTo(size, cur_d);
    ctx.lineTo(0, cur_d);
    ctx.stroke();

    const datauri = hcanvas.toDataURL('image/png');
    gridimg.setAttribute('width', size);
    gridimg.setAttribute('height', size);

    // #gridpattern
    gridimg.parentNode.setAttribute('width', size);
    gridimg.parentNode.setAttribute('height', size);

    gridimg.parentNode.setAttribute('x', Math.floor((canvas.contentW * zoom) / 2 - size));
    gridimg.parentNode.setAttribute('y', Math.floor((canvas.contentH * zoom) / 2 - size));

    canvas.setHref(gridimg, datauri);
  }

  return {

    zoomChanged: function (zoom) {
      if (!isEnabled || !zoom) {
        return;
      }

      updateGrid(zoom);
    },

    enableRuler: function () {
      if (isEnabled || INKIVE.C.IS_MOBILE) {
        return;
      }

      const that = this;
      isEnabled = true;

      init();

      $('#ik-grid-snap').off('click');
      $('#ik-grid-snap').on('click', function () {
        $(this).toggleClass('active');
        if ($(this).hasClass('active')) {
          that.enableGrid();
        } else {
          that.disableGrid();
        }
      });
    },

    disableRuler: function () {
      if (!isEnabled) {
        return;
      }

      isEnabled = false;

      this.disableGrid();
      $('#ik-grid-snap').hide();
      $('#ik-grid-snap').removeClass('active');
    },

    enableGrid: function () {
      curConfig.gridSnapping = true;

      updateGrid(canvas.getZoom());

      $('#canvasGrid').show();
    },

    disableGrid: function () {
      curConfig.gridSnapping = false;

      $('#canvasGrid').hide();
    }
  };
};
